import {
  EXPLORER_ADD_FOLDER_TOGGLED,
  EXPLORER_ADD_PAGE_TOGGLED,
  EXPLORER_CREATE_MASTER_COMPONENT_TOGGLED
} from './const';

// TODO this ui state can be handled by component internal state
export const defaultState = {
  showAddFolderInput: false,
  showAddPageDialog: false,
  showCreateMasterComponentDialog: false
};

/**
 * reducer for Explorer state
 * @param {object} state - the current state
 * @param {object} action - the action causing a state change
 * @returns {object} the next state
 */
const reducer = function explorerReducer(state = defaultState, action = {}) {
  if (!action) {
    return state;
  }
  switch (action.type) {
    case EXPLORER_ADD_FOLDER_TOGGLED:
      return { ...state, showAddFolderInput: !state.showAddFolderInput };
    case EXPLORER_ADD_PAGE_TOGGLED:
      return { ...state, showAddPageDialog: !state.showAddPageDialog };
    case EXPLORER_CREATE_MASTER_COMPONENT_TOGGLED:
      return {
        ...state,
        showCreateMasterComponentDialog: !state.showCreateMasterComponentDialog
      };
    default:
      return state;
  }
};

export default reducer;
